import React from "react";
import { Link } from "react-router-dom";

export default function NavItem({ href, text }) {
  return (
    <Link to={href} className="text-white py-2 px-3 d-block">
      {text}
    </Link>
  );
}
